import { gql } from '@apollo/client'

import accessControlFragment from 'js/components/EntityActions/fragments/accessControl'
import { rowsViewFragment } from 'js/page/Page/rowsFragment'

export const EDIT_PAGE_IN_EDITOR = gql`
    mutation EditPageInEditor($input: editPageInput!) {
        editPage(input: $input) {
            entity {
                guid
                ... on Page {
                    title
                    timeUpdated
                    rows {
                        ${rowsViewFragment}
                    }
                    ${accessControlFragment}
                }
            }
        }
    }
`
